import { Component } from '@angular/core';
import { BreadcrumbService } from '../../../../breadcrumb.service';
import { CaptivePortal } from './cp.model';
import { RouterConst } from '../../../../globals/RoutersConst';
import { isNullOrUndefined, isUndefined } from 'util';
import { ClientsService } from '../../../../services/clients/clients.service';
import { Globals } from '../../../../globals/Globals';
import { SuperClass } from '../../../../superclass/SuperClass';
import { DashboardDataService } from '../../../../services/dashboard-data.service';
import { WsService } from '../../../../services/websocket/WsService';
import { EmailAccount } from '../../accounts/email-accounts/email-account.model';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Region } from '../../regions/region.model';

@Component({
  selector: 'app-cp-add-update',
  templateUrl: './cp-add-update.component.html',
  styleUrls: ['./cp-add-update.component.css'],
})
export class CpAddUpdateComponent extends SuperClass {
  cpList: CaptivePortal[];
  selectedPortal;

  selectedRow: CaptivePortal;
  newCP: CaptivePortal;
  newCPForm: FormGroup;
  selectedRowForm: FormGroup;

  display = false;

  cpCodes;
  venues;
  cpLocaleCodes;
  languages;
  redirectOptions;
  clients;

  twitterAccounts;
  facebookAccounts;
  googleAccounts;
  emailAccounts: EmailAccount[];
  smsAccounts;
  paypalAccounts;
  mailchimpAccounts;
  redirectStrategies;
  regions: Region[];

  wiredMessengerAccounts = [];
  mailchimpLists = [];
  mailchimpGroups = [];
  mailchimpGroupCategories = [];

  templatesList;
  useMessagingStrategy;
  messagingStrategies;
  messagingStrategy;

  isDropdownShown;
  useWiredmessenger = false;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
    private fb: FormBuilder,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.newCP = new CaptivePortal();

    this.breadcrumbService.setItems([
      { label: 'Organization' },
      { label: 'Captive Portal' },
      {
        label: 'Add/Update',
        routerLink: [{ outlets: { sub: [RouterConst.ADD_UPDATE] } }],
      },
    ]);
  }

  reloadData() {
    this.http_getTemplateNames((data: any) => {
      this.templatesList = data.payload;
    });
    this.http_getAllCp((data: any) => {
      this.cpList = data.payload;
    });
    this.http_getAllRegions((data: any) => {
      this.regions = data.payload;
    });

    this.http_getAllClients((data: any) => {
      this.clients = data.payload;
    });

    this.http_getAllCpCodes((data: any) => {
      this.cpCodes = data.payload;
    });

    this.http_getRedirectOptions((data: any) => {
      this.redirectOptions = data.payload;
    });

    this.http_getAllLocations((data: any) => {
      this.venues = data.payload;
    });

    this.http_getAllAccounts('twitter', (data: any) => {
      this.twitterAccounts = data.payload;
    });

    this.http_getAllAccounts('facebook', (data: any) => {
      this.facebookAccounts = data.payload;
    });

    this.http_getAllAccounts('google', (data: any) => {
      this.googleAccounts = data.payload;
    });

    this.http_getAllAccounts('email', (data: any) => {
      this.emailAccounts = data.payload;
    });

    this.http_getAllAccounts('sms', (data: any) => {
      this.smsAccounts = data.payload;
    });

    this.http_getAllAccounts('paypal', (data: any) => {
      this.paypalAccounts = data.payload;
    });

    this.http_getAllAccounts('mailchimp', (data: any) => {
      this.mailchimpAccounts = data.payload;
    });

    this.http_getAllAccounts('wiredmessenger', (data: any) => {
      this.wiredMessengerAccounts = data.payload;
    });

    this.http_getRedirectStrategies((data: any) => {
      this.redirectStrategies = data.payload;
    });

    this.http_getMessagingStrategies((data: any) => {
      this.messagingStrategies = data.payload;
    });

    this.selectedRowForm = this.fb.group({
      cpCode: new FormControl('', Validators.required),
      cpTitle: new FormControl('', Validators.required),
      nasid: new FormControl('', Validators.required),
      venueCode: new FormControl('', Validators.required),
    });

    this.newCPForm = this.fb.group({
      cpCode: new FormControl('', Validators.required),
      cpTitle: new FormControl('', Validators.required),
      nasid: new FormControl('', Validators.required),
      venueCode: new FormControl('', Validators.required),
    });
  }

  getWebSocketIdentifier(): string {
    return undefined;
  }

  selectRow(e) {
    if (!isUndefined(this.selectedRow) && e.data.id === this.selectedRow.id) {
      this.unselectRow();
      return;
    }

    this.selectedRow = new CaptivePortal(e.data);
    console.log(e.data);

    this.selectedRow.captivePortalCode = this.cpCodes.filter(el => {
      return el.cpCode === this.selectedRow.captivePortalCode;
    })[0];

    if (this.selectedRow.redirectOption !== null) {
      const redirectOption = this.selectedRow.redirectOption;
      this.selectedRow.redirectOption = this.redirectOptions.filter(el => {
        return el.description === redirectOption;
      })[0];
    }

    this.http_getLocalesByCpCode(
      { cpCode: this.selectedRow.captivePortalCode.cpCode },
      (data: any) => {
        this.cpLocaleCodes = data.payload;
        if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
          this.showCpLocaleCode();
        }
      },
    );

    this.isDropdownShown = e.data.use_template;

    if (
      this.selectedRow.captivePortalCode !== '' &&
      this.selectedRow.cpLocaleCode !== ''
    ) {
      const requestBody = {
        cpCode: this.selectedRow.captivePortalCode.cpCode,
        cpLocale: this.selectedRow.cpLocaleCode,
      };

      this.http_getLanguages(requestBody, (data: any) => {
        this.languages = data.payload;
        if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
          this.showCpLanguage();
        }
      });
    }

    if (
      this.selectedRow.useMailchimp &&
      !isNullOrUndefined(this.selectedRow.mailchimpAccount)
    ) {
      this.http_getMailchimpLists(
        this.selectedRow.mailchimpAccount.id,
        (dataLists: any) => {
          if (dataLists.result === Globals.RESPONSE_RESULT_SUCCESS) {
            this.mailchimpLists = JSON.parse(dataLists.payload).lists;
            if (
              !isNullOrUndefined(this.selectedRow.mailchimpListId) &&
              this.selectedRow.mailchimpListId !== ''
            ) {
              this.selectedRow.mailchimpList = this.mailchimpLists.filter(
                el => {
                  return el.id === this.selectedRow.mailchimpListId;
                },
              )[0];
              this.http_getMailchimpGroups(
                this.selectedRow.mailchimpAccount.id,
                this.selectedRow.mailchimpList.id,
                (dataGroups: any) => {
                  if (dataGroups.result === Globals.RESPONSE_RESULT_SUCCESS) {
                    this.mailchimpGroups = JSON.parse(
                      dataGroups.payload,
                    ).categories;
                    if (
                      !isNullOrUndefined(this.selectedRow.mailchimpGroupId) &&
                      this.selectedRow.mailchimpGroupId !== ''
                    ) {
                      this.selectedRow.mailchimpGroup = this.mailchimpGroups.filter(
                        el => {
                          return el.id === this.selectedRow.mailchimpGroupId;
                        },
                      )[0];
                      this.http_getMailchimpGroupCategories(
                        this.selectedRow.mailchimpAccount.id,
                        this.selectedRow.mailchimpList.id,
                        this.selectedRow.mailchimpGroup.id,
                        (dataGropCategories: any) => {
                          if (
                            dataGropCategories.result ===
                            Globals.RESPONSE_RESULT_SUCCESS
                          ) {
                            this.mailchimpGroupCategories = JSON.parse(
                              dataGropCategories.payload,
                            ).interests;
                            if (
                              !isNullOrUndefined(
                                this.selectedRow.mailchimpGroupCategoryId,
                              ) &&
                              this.selectedRow.mailchimpGroupCategoryId !== ''
                            ) {
                              this.selectedRow.mailchimpGroupCategory = this.mailchimpGroupCategories.filter(
                                el => {
                                  return (
                                    el.id ===
                                    this.selectedRow.mailchimpGroupCategoryId
                                  );
                                },
                              )[0];
                            }
                          }
                        },
                      );
                    }
                  }
                },
              );
            }
          }
        },
      );
    }
  }

  chooseCpCode(e) {
    this.http_getLocalesByCpCode({ cpCode: e.value.cpCode }, (data: any) => {
      this.cpLocaleCodes = data.payload;
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        this.showCpLocaleCode();
      }
    });
  }

  chooseLocaleCode(e) {
    const requestBody = {
      cpCode: e.value.cpCode,
      cpLocale: e.value.cpLocaleCode,
    };
    this.http_getLanguages(requestBody, (data: any) => {
      this.languages = data.payload;
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        this.showCpLanguage();
      }
    });
    console.log('teeeest:', this.languages);
  }

  showCpLocaleCode() {
    if (!isUndefined(this.selectedRow)) {
      return (this.selectedRow.cpLocaleCode = this.cpLocaleCodes.filter(el => {
        return el.cpLocaleCode === this.selectedRow.cpLocaleCode;
      })[0]);
    }
  }

  showCpLanguage() {
    if (!isUndefined(this.selectedRow)) {
      return (this.selectedRow.defaultLanguageCode = this.languages.filter(
        el => {
          return el.lang === this.selectedRow.defaultLanguageCode;
        },
      )[0]);
    }
  }

  switchOption(option) {
    switch (option) {
      case 'wiredmessenger': {
        this.selectedRow.useMailchimp = false;
        this.selectedRow.useMessagingStrategy = false;
        this.selectedRow.sendEmailAfterLogin = false;
        break;
      }
      case 'mailchimp': {
        this.selectedRow.useWiredmessenger = false;
        this.selectedRow.useMessagingStrategy = false;
        this.selectedRow.sendEmailAfterLogin = false;
        break;
      }
      case 'sendEmail': {
        this.selectedRow.useWiredmessenger = false;
        this.selectedRow.useMessagingStrategy = false;
        this.selectedRow.useMailchimp = false;
        break;
      }
      case 'messagingStrategy': {
        this.selectedRow.useWiredmessenger = false;
        this.selectedRow.useMailchimp = false;
        this.selectedRow.sendEmailAfterLogin = false;
        break;
      }
    }
  }

  saveCP() {
    const cp = new CaptivePortal(this.selectedRow);

    this.prepareCP(cp);

    const requiredFields = [
      { id: 'new_cpCode', value: cp.captivePortalCode, fieldName: 'CP code' },
      { id: 'cp_title', value: cp.cpTitle, fieldName: 'CP title' },
      { id: 'nasid', value: cp.nasid, fieldName: 'Nas Id' },
      { id: 'venues', value: cp.venues, fieldName: 'venue code' },
    ];
    if (this.hasEmptyFields(requiredFields)) {
      return;
    }

    const conditions = [
      {
        condition: cp.allowEmailLogin && isNullOrUndefined(cp.emailAccount),
        id: 'email_account',
        message: "Email Account can't be empty",
      },
      {
        condition:
          cp.allowFacebookLogin && isNullOrUndefined(cp.facebookAccount),
        id: 'email_account',
        message: "Facebook Account can't be empty",
      },
      {
        condition: cp.allowGoogleLogin && isNullOrUndefined(cp.googleAccount),
        id: 'email_account',
        message: "Google Account can't be empty",
      },
      {
        condition: cp.allowTwitterLogin && isNullOrUndefined(cp.twitterAccount),
        id: 'email_account',
        message: "Twitter Account can't be empty",
      },
      {
        condition: cp.allowPaypalLogin && isNullOrUndefined(cp.paypalAccount),
        id: 'email_account',
        message: "PayPal Account can't be empty",
      },
      {
        condition: cp.allowSms && isNullOrUndefined(cp.smsAccount),
        id: 'email_account',
        message: "SMS Account can't be empty",
      },
    ];
    if (this.hasErrorConditions(conditions)) {
      return;
    }

    this.http_updateCp(cp, (data: any) => {
      this.showSuccessMessage('CP has been updated');
      this.unselectRow();
      this.cpList = data.payload;
    });
  }

  addNewCP() {
    this.unselectRow();
    this.display = true;
  }

  cloneCP() {
    this.newCP = this.selectedRow;
    this.newCP.id = undefined;
    this.newCP.nasid = '';
    this.unselectRow();
    this.display = true;
  }

  createNewCP() {
    const cp = new CaptivePortal(this.newCP);

    this.prepareCP(cp);

    const requiredFields = [
      {
        id: 'new_captivePortalCode',
        value: cp.captivePortalCode,
        fieldName: 'CP code',
      },
      { id: 'new_cp_title', value: cp.cpTitle, fieldName: 'CP Title' },
      { id: 'new_nasid', value: cp.nasid, fieldName: 'nasid' },
      { id: 'new_venues', value: cp.venues, fieldName: 'Venue Code' },
    ];
    if (this.hasEmptyFields(requiredFields)) {
      return;
    }

    this.http_createCP(cp, (data: any) => {
      this.showSuccessMessage('CP has been created');
      this.unselectRow();
      this.cpList = data.payload;
      this.display = false;
    });
  }

  deleteCP() {
    this.http_deleteCP({ id: this.selectedRow.id }, (data: any) => {
      this.showSuccessMessage('CP has been deleted');
      this.unselectRow();
      this.cpList = data.payload;
    });
  }

  unselectRow() {
    this.selectedRow = undefined;
    this.selectedPortal = [];
  }

  // wiredMessengerChanged() {
  //   const cp = this.selectedRow ? this.selectedRow : this.newCP;
  //   this.http_getAllAccounts('wiredmessenger', (data: any) => {
  //     if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
  //       this.wiredMessengerLists = JSON.parse(data.payload).lists;
  //     }
  //   });
  // }

  mailchimpAccChanged() {
    const cp = this.selectedRow ? this.selectedRow : this.newCP;
    this.http_getMailchimpLists(cp.mailchimpAccount.id, (data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        this.mailchimpLists = JSON.parse(data.payload).lists;
      }
    });
  }

  mailchimpListChanged() {
    const cp = this.selectedRow ? this.selectedRow : this.newCP;
    this.http_getMailchimpGroups(
      cp.mailchimpAccount.id,
      cp.mailchimpList.id,
      (data: any) => {
        if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
          this.mailchimpGroups = JSON.parse(data.payload).categories;
          cp.mailchimpGroup = undefined;
          cp.mailchimpGroupCategory = undefined;
        }
      },
    );
  }

  mailchimpCategoryChanged() {
    const cp = this.selectedRow ? this.selectedRow : this.newCP;
    this.http_getMailchimpGroupCategories(
      cp.mailchimpAccount.id,
      cp.mailchimpList.id,
      cp.mailchimpGroup.id,
      (data: any) => {
        if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
          this.mailchimpGroupCategories = JSON.parse(data.payload).interests;
          cp.mailchimpGroupCategory = undefined;
        }
      },
    );
  }

  private prepareCP(cp: CaptivePortal) {
    cp.captivePortalCode = cp.captivePortalCode
      ? cp.captivePortalCode.cpCode
      : undefined;
    cp.cpLocaleCode = cp.cpLocaleCode
      ? cp.cpLocaleCode.cpLocaleCode
      : undefined;
    cp.defaultLanguageCode = cp.defaultLanguageCode
      ? cp.defaultLanguageCode.lang
      : undefined;
    cp.redirectOption = cp.redirectOption
      ? cp.redirectOption.description
      : undefined;

    cp.mailchimpListId = cp.mailchimpList ? cp.mailchimpList.id : undefined;
    cp.mailchimpListName = cp.mailchimpList ? cp.mailchimpList.name : undefined;
    cp.mailchimpGroupId = cp.mailchimpGroup ? cp.mailchimpGroup.id : undefined;
    cp.mailchimpGroupCategoryId = cp.mailchimpGroupCategory
      ? cp.mailchimpGroupCategory.id
      : undefined;
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/captive-portal/cp-add-update/cp-add-update.component.ts